<div style="width: 100%; background-color: #fff !important; padding-top: 10px;">
    <div id="topHeader" class="container">
        <img class="pull-right" src="./../assets/images/hallmark.png" alt="Chevron Hallmark"
            style="height:61px;width:54px;border-width:0px;" />
        <div id="sitenameTitle">
            <br>
            SA Accrual Management System
        </div>
        <div  >
          <app-menus></app-menus>
        </div>
    </div>
    
</div>
    <div class="container" style="padding-top: 1%">
        <div id="siteheaderImage">
            <img src="./../assets/images/AccuralHome.png"  >
        </div>
    </div>
    